import { TranslateContext } from '@denysvuika/preact-translate';
import { StartupScreen } from '@dora/components';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import { useTheme } from '@mui/material/styles';
import Preact from 'preact';
import * as Hooks from 'preact/hooks';
import * as Selectors from '../../store/selectors';
import { AppControlContext } from '../context/appControl';
import { useGetLogo } from '../hooks/byTenant/useGetLogo';
import { useSelector } from '../hooks/redux';

export function Component(props: { open: boolean }) {
    const appControl = Hooks.useContext(AppControlContext);
    const tenantIdentifier = useSelector(Selectors.Core.tenantIdentifier);
    const theme = useTheme();
    const logoUrl = useGetLogo();

    const { t } = Hooks.useContext(TranslateContext);

    return (
        <Fade
            in={props.open}
            exit
            appear={false}
            timeout={{
                enter: 0,
                exit: 1000,
            }}
        >
            <Box width="100%" height="100%" position="absolute" zIndex={theme.zIndex.modal}>
                {logoUrl && (
                    <StartupScreen.Component
                        onClose={() => appControl?.closeApp()}
                        logoUrl={`assets/${tenantIdentifier}/logo.svg`}
                        statusText={{
                            initial: t('i18n.space.initialLoading'),
                            middle: t('i18n.space.middleLoading'),
                            final: t('i18n.space.finalLoading'),
                        }}
                    />
                )}
            </Box>
        </Fade>
    );
}
